import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { Can } from "../Can";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Menu, CircularProgress } from "@material-ui/core";
import {
  MoreVert,
  SwapHorizOutlined,
  AccountBalanceWallet,
  FileCopy as FileCopyIcon,
  FlashOn,
  Add,
} from "@material-ui/icons";
import { v4 as uuidv4 } from "uuid";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
// import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import Tooltip from "@material-ui/core/Tooltip";
import ConfirmationModal from "../ConfirmationModal";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import Button from "@material-ui/core/Button";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";
import NewTicketModal from "../NewTicketModal";

import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import UndoIcon from "@material-ui/icons/Undo";

import MenuItem from "@material-ui/core/MenuItem";
import { Switch } from "@material-ui/core";
import { toast } from "react-toastify";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import ShowTicketLogModal from "../../components/ShowTicketLogModal";
import TicketMessagesDialog from "../TicketMessagesDialog";
import { useTheme } from "@material-ui/styles";
import FinalizacaoVendaModal from "../FinalizacaoVendaModal";
import QuickMessageModal from "../QuickMessageModal";
import { Phone } from "@material-ui/icons";
import FloupSelector from "../FloupSelector";

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    marginRight: 6,
    maxWidth: "100%",
    flex: "none",
    alignSelf: "center",
    marginLeft: "auto",
    // flexBasis: "50%",
    display: "flex",
    gap: 4,
    "& > *": {
      margin: 0,
    },
  },
  bottomButtonVisibilityIcon: {
    padding: 1,
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  botoes: {
    display: "flex",
    padding: "15px",
    justifyContent: "flex-end",
    maxWidth: "100%",
    // alignItems: "center"
  },
  crmOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 1600,
    backgroundColor: "rgba(0, 0, 0, 0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
  },
  crmModal: {
    width: "100%",
    maxWidth: 660,
    maxHeight: "92vh",
    overflow: "auto",
    backgroundColor: theme.mode === "light" ? "#fff" : "#1f1f1f",
    color: theme.mode === "light" ? "#222" : "#f5f5f5",
    borderRadius: 8,
    boxShadow: "0 18px 45px rgba(0, 0, 0, 0.35)",
  },
  crmModalTitle: {
    margin: 0,
    padding: "20px 24px",
    fontSize: 22,
    fontWeight: 700,
    borderBottom: `1px solid ${theme.mode === "light" ? "#e0e0e0" : "#333"}`,
  },
  crmModalBody: {
    padding: 24,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  crmField: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  crmLabel: {
    fontSize: 13,
    color: theme.mode === "light" ? "#666" : "#bbb",
  },
  crmInput: {
    width: "100%",
    boxSizing: "border-box",
    border: `1px solid ${theme.mode === "light" ? "#c9c9c9" : "#555"}`,
    borderRadius: 6,
    padding: "12px 14px",
    fontSize: 16,
    color: theme.mode === "light" ? "#222" : "#f5f5f5",
    backgroundColor: theme.mode === "light" ? "#fff" : "#2a2a2a",
    outlineColor: theme.palette.primary.main,
  },
  crmHelper: {
    margin: "2px 0 0",
    fontSize: 12,
    color: theme.mode === "light" ? "#777" : "#aaa",
  },
  crmActions: {
    padding: "16px 24px",
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
    borderTop: `1px solid ${theme.mode === "light" ? "#e0e0e0" : "#333"}`,
  },
}));

const SessionSchema = Yup.object().shape({
  ratingId: Yup.string().required("AvaliaÃƒÂ§ÃƒÂ£o obrigatÃƒÂ³ria"),
});

const TicketActionButtonsCustom = ({
  ticket,
  contact,
  supervisedUserId,
  onQuickMessageSelect,
  // , showSelectMessageCheckbox,
  // selectedMessages,
  // forwardMessageModalOpen,
  // setForwardMessageModalOpen
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isMounted = useRef(true);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
  const [open, setOpen] = React.useState(false);
  const formRef = React.useRef(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [
    acceptTicketWithouSelectQueueOpen,
    setAcceptTicketWithouSelectQueueOpen,
  ] = useState(false);
  const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const [disableBot, setDisableBot] = useState(ticket?.contact?.disableBot || false);

  const [enableIntegration, setEnableIntegration] = useState(
    ticket.useIntegration
  );

  const [showWavoipCall, setShowWavoipCall] = useState(false);

  const { get: getSetting } = useCompanySettings();
  const { getPlanCompany } = usePlans();

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const [showTestButton, setShowTestButton] = useState(false);
  const [linkingWallet, setLinkingWallet] = useState(false);

  const [openFinalizacaoVenda, setOpenFinalizacaoVenda] = useState(false);
  const [ticketDataToFinalize, setTicketDataToFinalize] = useState(null);
  const [showFinalizacaoOptions, setShowFinalizacaoOptions] = useState(false);
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false);

  // Estados para copiar telefone e respostas rÃƒÂ¡pidas
  const [quickMessageModalOpen, setQuickMessageModalOpen] = useState(false);
  const [crmLeadModalOpen, setCrmLeadModalOpen] = useState(false);
  const [crmLeadLoading, setCrmLeadLoading] = useState(false);
  const [crmIntegrationStatus, setCrmIntegrationStatus] = useState(null);
  const [crmLeadData, setCrmLeadData] = useState({
    nome: "",
    telefone: "",
    email: "",
    cpf: "",
    cursoInteresse: "",
    cidade: "",
  });

  const valorTextoSeguro = useCallback(
    (value) => (value === null || value === undefined ? "" : String(value)),
    []
  );

  const normalizarTelefoneBrasileiro = useCallback((value = "") => {
    let digits = String(value).replace(/\D/g, "").replace(/^0+/, "");

    if (digits.startsWith("55") && (digits.length === 12 || digits.length === 13)) {
      digits = digits.slice(2);
    }

    if (digits.length === 10) {
      digits = `${digits.slice(0, 2)}9${digits.slice(2)}`;
    }

    return digits.slice(0, 11);
  }, []);

  const formatarTelefoneBrasileiro = useCallback((value = "") => {
    const digits = normalizarTelefoneBrasileiro(value);
    if (!digits) return "";
    if (digits.length < 3) return `(${digits}`;

    const ddd = digits.slice(0, 2);
    const numero = digits.slice(2);
    if (numero.length <= 1) return `(${ddd}) ${numero}`;
    if (numero.length <= 5) return `(${ddd}) ${numero[0]} ${numero.slice(1)}`;

    return `(${ddd}) ${numero[0]} ${numero.slice(1, 5)}-${numero.slice(5, 9)}`;
  }, [normalizarTelefoneBrasileiro]);

  const limparNomeLead = useCallback(
    (value = "") =>
      String(value)
        .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "")
        .replace(/[\u2600-\u27BF]/g, "")
        .replace(/[^\w\u00C0-\u00FF\s.'-]/g, " ")
        .replace(/\s+/g, " ")
        .trim(),
    []
  );

  const buscarCampoExtraContato = useCallback((labels = []) => {
    const extraInfo = contact?.extraInfo || ticket?.contact?.extraInfo || [];
    if (!Array.isArray(extraInfo)) return "";

    const normalizedLabels = labels.map((label) => label.toLowerCase());
    const item = extraInfo.find((info) => {
      const name = String(info?.name || "").toLowerCase();
      return normalizedLabels.some((label) => name.includes(label));
    });

    return String(item?.value || "").trim();
  }, [contact?.extraInfo, ticket?.contact?.extraInfo]);

  const fetchData = useCallback(async () => {
    const companyId = user.companyId;
    const planConfigs = await getPlanCompany(undefined, companyId);

    if (isMounted.current) {
      setShowWavoipCall(planConfigs.plan.wavoip);
      setOpenTicketMessageDialog(false);
      setDisableBot(ticket?.contact?.disableBot || false);
      setShowTicketLogOpen(false);
    }
  }, [getPlanCompany, ticket?.contact?.disableBot, user.companyId]);

  const checkWhatsAppTriggerIntegration = useCallback(async () => {
    try {
      const { data } = await api.get(`/whatsapp/${ticket.whatsappId}`);
      if (isMounted.current) {
        setShowTestButton(data.triggerIntegrationOnClose === true);
      }
    } catch (err) {
      console.error(err);
      if (isMounted.current) {
        setShowTestButton(false);
      }
    }
  }, [ticket.whatsappId]);

  const fetchDirectTicketsToWalletsSetting = useCallback(async () => {
    try {
      const setting = await getSetting({
        column: "DirectTicketsToWallets"
      });
      if (isMounted.current) {
        setDirectTicketsToWallets(setting.DirectTicketsToWallets);
      }
    } catch (err) {
      console.error(err);
      if (isMounted.current) {
        setDirectTicketsToWallets(false);
      }
    }
  }, [getSetting]);

  useEffect(() => {
    fetchData();
    checkWhatsAppTriggerIntegration();
    fetchDirectTicketsToWalletsSetting();

    // Cleanup function to set isMounted to false when the component unmounts
    return () => {
      isMounted.current = false;
    };
  }, [checkWhatsAppTriggerIntegration, fetchData, fetchDirectTicketsToWalletsSetting]);

  const contactNome = contact?.name || ticket?.contact?.name || "";
  const contactTelefone = contact?.number || ticket?.contact?.number || "";
  const contactEmail = contact?.email || ticket?.contact?.email || "";

  useEffect(() => {
    setCrmLeadData((prev) => ({
      ...prev,
      nome: limparNomeLead(contactNome),
      telefone: formatarTelefoneBrasileiro(contactTelefone),
      email: contactEmail,
      cpf: buscarCampoExtraContato(["cpf"]) || prev.cpf || "",
      cursoInteresse:
        buscarCampoExtraContato(["curso", "interesse", "gradua\u00e7\u00e3o", "graduacao"]) ||
        prev.cursoInteresse ||
        "",
      cidade:
        buscarCampoExtraContato(["cidade", "munic\u00edpio", "municipio"]) ||
        prev.cidade ||
        "",
    }));
  }, [buscarCampoExtraContato, contactEmail, contactNome, contactTelefone, formatarTelefoneBrasileiro, limparNomeLead, ticket?.id]);

  useEffect(() => {
    if (!crmLeadModalOpen) return undefined;

    let active = true;

    const carregarStatusIntegracaoCrm = async () => {
      try {
        const { data } = await api.get("/crm-integration/status");
        if (active) {
          setCrmIntegrationStatus(data?.crm || null);
        }
      } catch (err) {
        console.error("Erro ao consultar status da integração com CRM:", err);
        if (active) {
          setCrmIntegrationStatus({
            configured: false,
            mode: "indisponivel"
          });
        }
      }
    };

    carregarStatusIntegracaoCrm();

    return () => {
      active = false;
    };
  }, [crmLeadModalOpen]);

  // Função para copiar telefone

  const handleCopyPhone = async () => {
    try {
      if (!contact?.number) {
        toast.error(i18n.t("ticketInfo.noPhone"));
        return;
      }

      // Buscar todas as configuraÃƒÂ§ÃƒÂµes relacionadas
      let prefix = "";
      let removeCountryCode = false;
      let removeAreaCode = false;
      let remove9thDigit = false;

      try {
        const settings = await Promise.all([
          getSetting({ column: "copyContactPrefix" }),
          getSetting({ column: "removeCountryCodeOnCopy" }),
          getSetting({ column: "removeAreaCodeOnCopy" }),
          getSetting({ column: "remove9thDigitOnCopy" })
        ]);

        prefix = settings[0]?.copyContactPrefix || "";
        removeCountryCode = settings[1]?.removeCountryCodeOnCopy || false;
        removeAreaCode = settings[2]?.removeAreaCodeOnCopy || false;
        remove9thDigit = settings[3]?.remove9thDigitOnCopy || false;
      } catch (err) {
        console.error('Erro ao buscar configuraÃƒÂ§ÃƒÂµes:', err);
        // Continua com valores padrÃƒÂ£o se houver erro
      }

      // Remove todos os caracteres nÃƒÂ£o numÃƒÂ©ricos
      let phoneNumber = contact.number.replace(/\D/g, '');

      // Aplicar transformaÃƒÂ§ÃƒÂµes conforme checkboxes marcados
      // Ordem de processamento: 1) CÃƒÂ³digo do paÃƒÂ­s, 2) DDD, 3) 9Ã‚Âº dÃƒÂ­gito

      // 1. Remover cÃƒÂ³digo do paÃƒÂ­s (55) se marcado
      if (removeCountryCode && phoneNumber.startsWith('55') && phoneNumber.length > 10) {
        phoneNumber = phoneNumber.substring(2);
      }

      // 2. Remover cÃƒÂ³digo de ÃƒÂ¡rea (DDD - 2 primeiros dÃƒÂ­gitos) se marcado
      // O DDD sÃƒÂ£o os 2 primeiros dÃƒÂ­gitos apÃƒÂ³s o cÃƒÂ³digo do paÃƒÂ­s (ou do inÃƒÂ­cio se cÃƒÂ³digo foi removido)
      if (removeAreaCode) {
        // NÃƒÂºmero brasileiro completo tem 13 dÃƒÂ­gitos (55 + DDD + 9 + nÃƒÂºmero)
        // ApÃƒÂ³s remover cÃƒÂ³digo do paÃƒÂ­s: 11 dÃƒÂ­gitos (DDD + 9 + nÃƒÂºmero)
        // ApÃƒÂ³s remover DDD: 9 dÃƒÂ­gitos (9 + nÃƒÂºmero)
        if (phoneNumber.length >= 10) {
          phoneNumber = phoneNumber.substring(2);
        }
      }

      // 3. Remover 9Ã‚Âº dÃƒÂ­gito (primeiro dÃƒÂ­gito do nÃƒÂºmero do celular) se marcado
      // O 9Ã‚Âº dÃƒÂ­gito ÃƒÂ© o primeiro dÃƒÂ­gito apÃƒÂ³s o DDD
      if (remove9thDigit) {
        // Se o DDD foi removido, o 9Ã‚Âº dÃƒÂ­gito ÃƒÂ© o primeiro dÃƒÂ­gito
        // Se o DDD ainda estÃƒÂ¡ presente, o 9Ã‚Âº dÃƒÂ­gito ÃƒÂ© o terceiro dÃƒÂ­gito (ÃƒÂ­ndice 2)
        if (removeAreaCode) {
          // DDD jÃƒÂ¡ foi removido, o 9Ã‚Âº dÃƒÂ­gito ÃƒÂ© o primeiro
          if (phoneNumber.length >= 9) {
            phoneNumber = phoneNumber.substring(1);
          }
        } else {
          // DDD ainda estÃƒÂ¡ presente, o 9Ã‚Âº dÃƒÂ­gito ÃƒÂ© o terceiro (apÃƒÂ³s os 2 do DDD)
          if (phoneNumber.length >= 11) {
            phoneNumber = phoneNumber.substring(0, 2) + phoneNumber.substring(3);
          } else if (phoneNumber.length === 10) {
            // Caso especial: nÃƒÂºmero sem cÃƒÂ³digo do paÃƒÂ­s mas com DDD
            phoneNumber = phoneNumber.substring(0, 2) + phoneNumber.substring(3);
          }
        }
      }

      // Se a sigla estiver configurada, adiciona antes do nÃƒÂºmero
      if (prefix && prefix.trim() !== "") {
        phoneNumber = `${prefix}${phoneNumber}`;
      }

      // Verifica se tem pelo menos 8 dÃƒÂ­gitos (nÃƒÂºmero mÃƒÂ­nimo vÃƒÂ¡lido)
      const digitsOnly = phoneNumber.replace(/\D/g, '');
      if (digitsOnly.length >= 8) {
        await navigator.clipboard.writeText(phoneNumber);
        toast.success(i18n.t("ticketInfo.phonecopied"));
      } else {
        toast.error(i18n.t("ticketInfo.invalidPhoneFormat"));
      }
    } catch (err) {
      console.error('Erro ao copiar telefone:', err);
      toast.error(i18n.t("ticketInfo.copyError"));
    }
  };

  // FunÃƒÂ§ÃƒÂµes para respostas rÃƒÂ¡pidas
  const handleOpenQuickMessageModal = () => {
    setQuickMessageModalOpen(true);
  };

  const handleCloseQuickMessageModal = () => {
    setQuickMessageModalOpen(false);
  };

  const handleQuickMessageSelect = useCallback((selectedMessage) => {
    handleCloseQuickMessageModal();

    if (selectedMessage.mediaPath) {
      const event = new CustomEvent('insertQuickMessage', {
        detail: {
          quickMessage: {
            id: selectedMessage.id,
            message: selectedMessage.message || "",
            shortcode: selectedMessage.shortcode || "",
            mediaPath: selectedMessage.mediaPath,
            mediaName: selectedMessage.mediaName || null, // Ã¢Å“â€¦ CORREÃƒâ€¡ÃƒÆ’O: Incluir mediaName
            mediaType: selectedMessage.mediaType,
            value: selectedMessage.message || ""
          }
        },
        bubbles: false
      });

      window.dispatchEvent(event);
    } else {
      // Para texto, tambÃƒÂ©m usar evento
      const event = new CustomEvent('insertQuickMessage', {
        detail: {
          quickMessage: {
            id: selectedMessage.id,
            message: selectedMessage.message || "",
            shortcode: selectedMessage.shortcode || "",
            mediaPath: null,
            mediaName: null,
            mediaType: null,
            value: selectedMessage.message || ""
          }
        },
        bubbles: false
      });

      window.dispatchEvent(event);
    }
  }, []);

  const handleClose = () => {
    formRef.current.resetForm();
    setOpen(false);
  };

  const handleOpenAcceptTicketWithouSelectQueue = async () => {
    setAcceptTicketWithouSelectQueueOpen(true);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenTransferModal = (e) => {
    setTransferTicketModalOpen(true);
    if (typeof handleClose == "function") handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    if (typeof handleClose == "function") handleClose();
  };

  const handleCloseTicketWithoutFarewellMsg = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: "closed",
        userId: user?.id || null,
        queueId: ticket?.queue?.id || ticket?.queueId || null, // Ã¢Å“â€¦ Preservar fila ao fechar
        sendFarewellMessage: false,
        amountUsedBotQueues: 0,
      });

      setLoading(false);
      history.push("/tickets");
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleExportPDF = async () => {
    setOpenTicketMessageDialog(true);
    handleCloseMenu();
  };

  const handleEnableIntegration = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        useIntegration: !enableIntegration,
      });
      setEnableIntegration(!enableIntegration);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleShowLogTicket = async () => {
    setShowTicketLogOpen(true);
  };

  const handleContactToggleDisableBot = async () => {
    if (!ticket?.contact?.id) {
      toastError(new Error("Contato nÃƒÂ£o encontrado"));
      return;
    }

    const { id } = ticket.contact;

    try {
      const { data } = await api.put(`/contacts/toggleDisableBot/${id}`);
      if (ticket.contact) {
        ticket.contact.disableBot = data.disableBot;
      }
      setDisableBot(data.disableBot);
    } catch (err) {
      toastError(err);
    }
  };

  const handleCloseTransferTicketModal = () => {
    setTransferTicketModalOpen(false);
  };

  const handleOpenNewTicketModal = () => {
    setNewTicketModalOpen(true);
  };

  const handleCloseNewTicketModal = (newTicket) => {
    setNewTicketModalOpen(false);
    if (newTicket) {
      // Se um novo ticket foi criado, redirecionar para ele
      setCurrentTicket({ id: newTicket.id, uuid: newTicket.uuid, code: uuidv4() });
      history.push(`/tickets/${newTicket.uuid}`);
    }
  };

  const handleDeleteTicket = async () => {
    try {
      await api.delete(`/tickets/${ticket.id}`);
      history.push("/tickets");
    } catch (err) {
      toastError(err);
    }
  };

  const handleSendMessage = async (id, ticketData = ticket) => {
    const connectionGreetingMessage = ticketData?.whatsapp?.greetingMessage?.trim();
    let setting = {};

    if (!connectionGreetingMessage) {
      try {
        setting = await getSetting({
          column: "greetingAcceptedMessage",
        });
      } catch (err) {
        toastError(err);
      }
    }

    const msg = connectionGreetingMessage || `${setting.greetingAcceptedMessage || ""}`;

    if (!msg.trim()) {
      toast.warning(
        i18n.t("messagesList.header.buttons.greetingAcceptedMessage")
      );
      return;
    }
    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: `${msg.trim()}`,
    };
    try {
      await api.post(`/messages/${id}`, message);
    } catch (err) {
      toastError(err);
    }
  };

  const handleUpdateTicketStatus = async (e, status, userId, queueId) => {
    setLoading(true);
    try {
      const { data: updatedTicket } = await api.put(`/tickets/${ticket.id}`, {
        status: status,
        userId: userId || null,
        queueId: queueId || ticket?.queue?.id || ticket?.queueId || null, // Ã¢Å“â€¦ Preservar fila ao fechar
      });

      let setting;

      try {
        setting = await getSetting({
          column: "sendGreetingAccepted",
        });
      } catch (err) {
        toastError(err);
      }

      if (
        setting?.sendGreetingAccepted === "enabled" &&
        (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled") &&
        ticket.status === "pending"
      ) {
        handleSendMessage(ticket.id, updatedTicket);
      }

      if (isMounted.current) {
        setLoading(false);
      }

      if (status === "open" || status === "group") {
        setCurrentTicket({ ...updatedTicket, code: "#" + status });
        setTimeout(() => {
          history.push("/tickets");
        }, 0);

        setTimeout(() => {
          history.push(`/tickets/${updatedTicket.uuid || ticket.uuid}`);
          setTabOpen(status);
        }, 10);
      } else {
        setCurrentTicket({ id: null, code: null });
        history.push("/tickets");
      }
    } catch (err) {
      if (isMounted.current) {
        setLoading(false);
      }
      toastError(err);
    }
  };

  //Wavoip historic
  const saveHistoricalLink = async (payload) => {
    try {
      await api.post(`/call/historical/wavoip`, payload);
    } catch (err) {
      console.error('Erro ao salvar histÃƒÂ³rico de chamada:', err);
    }
  }
  // Click-to-call: abre o webphone oficial e inicia a ligaÃƒÂ§ÃƒÂ£o com o nÃƒÂºmero do contato
  const handleOpenWavoipCall = async () => {
    if (!ticket?.contact?.number) {
      toastError("Erro: NÃƒÂºmero de telefone nÃƒÂ£o disponÃƒÂ­vel.");
      return;
    }

    const token = ticket?.whatsapp?.wavoip || null;
    const phone = ticket.contact.number.replace(/\D/g, "");
    const name = ticket.contact.name || "";
    const url = `https://app.wavoip.com/call?token=${token}&phone=${phone}&name=${name}&start_if_ready=true&close_after_call=true`;

    // Salva histÃƒÂ³rico em segundo plano (nÃƒÂ£o bloqueia a ligaÃƒÂ§ÃƒÂ£o)
    saveHistoricalLink({
      "user_id": ticket?.user?.id || null,
      "token_wavoip": token,
      "whatsapp_id": ticket?.whatsapp?.id || null,
      "contact_id": ticket?.contact?.id || null,
      "company_id": ticket?.company?.id || null,
      "phone_to": phone,
      "name": name,
      "url": url,
      "createdAt": new Date()
    }).catch((e) => console.error('Erro ao salvar histÃƒÂ³rico de chamada:', e));

    // PreferÃƒÂªncia: webphone novo (widget oficial) com click-to-call Ã¢â‚¬â€ resposta imediata
    if (typeof window !== "undefined" && window.wavoip) {
      try {
        window.wavoip.widget.toggle();
        window.wavoip.settings.setShowSettings(false);
        if (window.wavoip?.position?.set) {
          window.wavoip.position.set("bottom-right");
        }
        const tokenToUse = token;
        if (tokenToUse) {
          window.wavoip.device.addDevice(tokenToUse);
          const result = await window.wavoip.call.startCall(phone, [tokenToUse]);
          if (result?.err) {
            toastError(result.err?.message || "Erro ao iniciar chamada.");
          }
        } else {
          toastError("Token WAVoIP nÃƒÂ£o disponÃƒÂ­vel para esta conexÃƒÂ£o.");
        }
      } catch (err) {
        console.error("Erro click-to-call webphone:", err);
        toastError(err?.message || "Erro ao abrir webphone.");
        if (token) {
          window.open(url, "wavoip", "toolbar=no,scrollbars=no,resizable=no,top=500,left=500,width=500,height=700");
        }
      }
      return;
    }

    // Fallback: popup externo quando o widget ainda nÃƒÂ£o estiver carregado
    if (token) {
      window.open(url, "wavoip", "toolbar=no,scrollbars=no,resizable=no,top=500,left=500,width=500,height=700");
    } else {
      toastError("Token WAVoIP nÃƒÂ£o disponÃƒÂ­vel. Aguarde o carregamento do webphone ou tente novamente.");
    }
  };

  const handleTestButton = async () => {
    try {
      if (ticket?.whatsapp?.integrationTypeId) {
        const { data: integration } = await api.get(
          `/queueIntegration/${ticket.whatsapp.integrationTypeId}`
        );

        if (integration) {
          await api.post(`/queueIntegration/testsession`, {
            integrationId: ticket.whatsapp.integrationTypeId,
            ticketId: ticket.id,
            contactId: ticket.contactId,
            body: ticket.lastMessage?.body || "",
            status: "closed",
          });

          if (isMounted.current) {
            toast.success(i18n.t("ticketList.success.integrationTriggered"));
          }
        }
      }

      await handleUpdateTicketStatus(
        null,
        "closed",
        user?.id,
        ticket?.queue?.id
      );

      if (isMounted.current) {
        handleClose();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleLinkToWallet = async () => {
    if (!ticket.contactId) {
      toast.error(i18n.t("contactModal.saveFirst"));
      return;
    }

    setLinkingWallet(true);
    try {
      if (!user.queues || user.queues.length === 0) {
        toast.error(i18n.t("contactModal.walletError"));
        return;
      }

      // Usa a primeira fila do usuÃ¡rio
      const userQueue = user.queues[0];

      await api.put(`/contacts/wallet/${ticket.contactId}`, {
        wallets: {
          userId: user.id,
          queueId: ticket.queueId || userQueue.id,
        },
      });

      toast.success(i18n.t("contactModal.walletLinked"));
    } catch (err) {
      toastError(err);
    } finally {
      setLinkingWallet(false);
    }
  };

  const handleOpenCrmLeadModal = () => {
    setCrmIntegrationStatus(null);
    setCrmLeadModalOpen(true);
  };

  const handleCloseCrmLeadModal = () => {
    if (!crmLeadLoading) {
      setCrmLeadModalOpen(false);
    }
  };

  const handleChangeCrmLeadData = (field) => (event) => {
    const rawValue = event?.target?.value ?? "";
    const value =
      field === "telefone" ? formatarTelefoneBrasileiro(rawValue) : rawValue;
    setCrmLeadData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSendLeadToCrm = async () => {
    if (!ticket?.id) {
      toast.error("Selecione um atendimento antes de enviar para o CRM.");
      return;
    }

    if (!crmLeadData.telefone) {
      toast.error("Informe o telefone do lead antes de enviar para o CRM.");
      return;
    }

    setCrmLeadLoading(true);
    try {
      const statusResponse = crmIntegrationStatus
        ? { data: { crm: crmIntegrationStatus } }
        : await api.get("/crm-integration/status");
      setCrmIntegrationStatus(statusResponse.data?.crm || null);

      if (!statusResponse.data?.crm?.configured) {
        const mode = statusResponse.data?.crm?.mode || "desconhecido";
        const source = statusResponse.data?.crm?.source || "desconfigurado";
        const missing = Array.isArray(statusResponse.data?.crm?.missing)
          ? statusResponse.data.crm.missing.join(", ")
          : "";
        toast.error(
          `Integração com CRM não configurada. Origem: ${source} (${mode}).${missing ? ` Campos faltando: ${missing}.` : ""} Configure em Administração > Configurações.`
        );
        return;
      }

      const { data } = await api.post("/crm-integration/leads/from-ticket", {
        ticketId: ticket.id,
        supervisedUserId,
        lead: {
          ...crmLeadData,
          telefone: normalizarTelefoneBrasileiro(crmLeadData.telefone),
        },
      });

      toast.success(data?.message || "Lead enviado para o CRM.");
      setCrmLeadModalOpen(false);
    } catch (err) {
      toastError(err);
    } finally {
      setCrmLeadLoading(false);
    }
  };

  const handleFinalizarTicket = async (tipo) => {
    if (
      user.finalizacaoComValorVendaAtiva === true ||
      user.finalizacaoComValorVendaAtiva === "true"
    ) {
            setOpenFinalizacaoVenda(true);
    } else {
      if (tipo === "semDespedida") {
        handleCloseTicketWithoutFarewellMsg();
      } else {
        handleUpdateTicketStatus(null, "closed", user?.id, ticket?.queue?.id);
      }
    }
  };

  const handleClickResolver = () => {
    if (
      user.finalizacaoComValorVendaAtiva === true ||
      user.finalizacaoComValorVendaAtiva === "true"
    ) {
            setOpenFinalizacaoVenda(true);
    } else {
      setOpen(true);
    }
  };

  const handleUpdateTicketStatusWithData = async (
    ticketData,
    sendFarewellMessage,
    finalizacaoMessage
  ) => {
    try {
      await api.put(`/tickets/${ticket.id}`, {
        ...ticketData,
        sendFarewellMessage,
        finalizacaoMessage,
      });
      toast.success("Ticket finalizado com sucesso!");
      // Atualize o estado conforme necessÃƒÂ¡rio
    } catch (err) {
      toastError(err);
    }
  };

  // Tooltip dinÃƒÂ¢mico para copiar telefone
  const getCopyPhoneTooltip = () => {
    const usePrefixWhenCopy = localStorage.getItem('usePrefixWhenCopy') === 'true';
    const prefix = localStorage.getItem('contactCopyPrefix') || '';

    let copyTooltip = i18n.t("ticketInfo.copyPhone");
    if (usePrefixWhenCopy && prefix) {
      copyTooltip = `Copiar telefone com prefixo (${prefix})`;
    }
    return copyTooltip;
  };

  return (
    <>\r\n      {acceptTicketWithouSelectQueueOpen && (
        <AcceptTicketWithouSelectQueue
          modalOpen={acceptTicketWithouSelectQueueOpen}
          onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
          ticketId={ticket.id}
          ticket={ticket}
        />
      )}
      {showTicketLogOpen && (
        <ShowTicketLogModal
          isOpen={showTicketLogOpen}
          handleClose={(e) => setShowTicketLogOpen(false)}
          ticketId={ticket.id}
        />
      )}
      {openTicketMessageDialog && (
        <TicketMessagesDialog
          open={openTicketMessageDialog}
          handleClose={() => setOpenTicketMessageDialog(false)}
          ticketId={ticket.id}
        />
      )}

      {quickMessageModalOpen && (
        <QuickMessageModal
          open={quickMessageModalOpen}
          onClose={handleCloseQuickMessageModal}
          onSelect={handleQuickMessageSelect}
          companyId={user?.companyId}
          userId={user?.id}
        />
      )}

      {crmLeadModalOpen && (
        <div
          className={classes.crmOverlay}
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              handleCloseCrmLeadModal();
            }
          }}
        >
          <div
            className={classes.crmModal}
            role="dialog"
            aria-modal="true"
            aria-labelledby="crm-lead-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <h2 id="crm-lead-title" className={classes.crmModalTitle}>
              Enviar lead para CRM
            </h2>
            <div className={classes.crmModalBody}>
              <div style={{ fontSize: 12, color: theme.palette.text.secondary }}>
                Status da integração com CRM:{" "}
                <strong>
                  {crmIntegrationStatus?.configured
                    ? `configurada (${crmIntegrationStatus.mode || "url"})`
                    : `não configurada (${crmIntegrationStatus?.mode || "desconhecido"})`}
                </strong>
              </div>
              {Array.isArray(crmIntegrationStatus?.missing) && crmIntegrationStatus.missing.length > 0 && (
                <div style={{ fontSize: 12, color: theme.palette.text.secondary, lineHeight: 1.4 }}>
                  Campos faltando: <strong>{crmIntegrationStatus.missing.join(", ")}</strong>
                </div>
              )}
              {!crmIntegrationStatus?.configured && (
                <div style={{ fontSize: 13, color: theme.palette.text.secondary, lineHeight: 1.4 }}>
                  Para ativar o envio automático, cadastre a URL do CRM, o domínio da hospedagem e o token em
                  <strong> Administração &gt; Configurações &gt; Opções</strong>.
                </div>
              )}
              <label className={classes.crmField}>
                <span className={classes.crmLabel}>Nome completo</span>
                <input
                  className={classes.crmInput}
                  value={valorTextoSeguro(crmLeadData.nome)}
                  onChange={handleChangeCrmLeadData("nome")}
                  autoFocus
                />
              </label>
              <label className={classes.crmField}>
                <span className={classes.crmLabel}>Telefone</span>
                <input
                  className={classes.crmInput}
                  value={valorTextoSeguro(crmLeadData.telefone)}
                  onChange={handleChangeCrmLeadData("telefone")}
                  inputMode="tel"
                />
                <p className={classes.crmHelper}>
                  O CRM usa o telefone para evitar cadastro duplicado do lead.
                </p>
              </label>
              <label className={classes.crmField}>
                <span className={classes.crmLabel}>E-mail</span>
                <input
                  className={classes.crmInput}
                  value={valorTextoSeguro(crmLeadData.email)}
                  onChange={handleChangeCrmLeadData("email")}
                  inputMode="email"
                />
              </label>
              <label className={classes.crmField}>
                <span className={classes.crmLabel}>CPF do lead</span>
                <input
                  className={classes.crmInput}
                  value={valorTextoSeguro(crmLeadData.cpf)}
                  onChange={handleChangeCrmLeadData("cpf")}
                  inputMode="numeric"
                />
                <p className={classes.crmHelper}>
                  Opcional para o lead. Para vincular o envio ao CRM, o CPF obrigatório é o do atendente cadastrado no Atende e no CRM.
                </p>
              </label>
              <label className={classes.crmField}>
                <span className={classes.crmLabel}>Curso de interesse</span>
                <input
                  className={classes.crmInput}
                  value={valorTextoSeguro(crmLeadData.cursoInteresse)}
                  onChange={handleChangeCrmLeadData("cursoInteresse")}
                />
              </label>
              <label className={classes.crmField}>
                <span className={classes.crmLabel}>Cidade</span>
                <input
                  className={classes.crmInput}
                  value={valorTextoSeguro(crmLeadData.cidade)}
                  onChange={handleChangeCrmLeadData("cidade")}
                />
              </label>
            </div>
            <div className={classes.crmActions}>
              {!crmIntegrationStatus?.configured && (
                <Button onClick={() => history.push("/settings")}>
                  Abrir configurações
                </Button>
              )}
              <Button onClick={handleCloseCrmLeadModal} disabled={crmLeadLoading}>
                Cancelar
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={handleSendLeadToCrm}
                disabled={crmLeadLoading}
              >
                {crmLeadLoading ? <CircularProgress size={20} /> : "Enviar para CRM"}
              </Button>
            </div>
          </div>
        </div>
      )}

      {newTicketModalOpen && (
        <NewTicketModal
          modalOpen={newTicketModalOpen}
          onClose={handleCloseNewTicketModal}
          initialContact={contact}
        />
      )}

      <div className={classes.actionButtons}>
        {ticket.status === "closed" && (
          <ButtonWithSpinner
            loading={loading}
            startIcon={<Add />}
            size="small"
            onClick={handleOpenNewTicketModal}
          >
            Criar Novo Ticket
          </ButtonWithSpinner>
        )}
        {/* <IconButton
                    className={classes.bottomButtonVisibilityIcon}
                    onClick={handleShowLogTicket}
                >
                    <Tooltip title={i18n.t("messagesList.header.buttons.logTicket")}>
                        <History />

                    </Tooltip>
                </IconButton> */}
        {(ticket.status === "open" || ticket.status === "group") && (
          <>
            {/* {!showSelectMessageCheckbox ? ( */}
            <>
              {/* <IconButton
                                className={classes.bottomButtonVisibilityIcon}
                                onClick={handleEnableIntegration}
                            >
                                <Tooltip title={i18n.t("messagesList.header.buttons.enableIntegration")}>
                                    {enableIntegration === true ? <DeviceHubOutlined style={{ color: "green" }} /> : <DeviceHubOutlined />}

                                </Tooltip>
                            </IconButton> */}

              {/* ÃƒÂcone para copiar telefone */}
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleCopyPhone}
                disabled={!contact?.number}
              >
                <Tooltip title={getCopyPhoneTooltip()}>
                  <FileCopyIcon />
                </Tooltip>
              </IconButton>

              {/* ÃƒÂcone para respostas rÃƒÂ¡pidas */}
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleOpenQuickMessageModal}
              >
                <Tooltip title={i18n.t("ticketInfo.quickMessages")}>
                  <FlashOn />
                </Tooltip>
              </IconButton>


              {/* BotÃƒÂ£o de vincular ÃƒÂ  carteira sÃƒÂ³ aparece se NÃƒÆ’O houver carteira vinculada E se a configuraÃƒÂ§ÃƒÂ£o DirectTicketsToWallets estiver ativa */}
              {directTicketsToWallets && !(
                ticket.contact?.contactWallets &&
                ticket.contact.contactWallets.length > 0
              ) && (
                  <IconButton
                    className={classes.bottomButtonVisibilityIcon}
                    onClick={handleLinkToWallet}
                    disabled={linkingWallet}
                  >
                    <Tooltip title="Vincular ÃƒÂ  minha carteira">
                      {linkingWallet ? (
                        <CircularProgress size={20} />
                      ) : (
                        <AccountBalanceWallet />
                      )}
                    </Tooltip>
                  </IconButton>
                )}
            </>

            {/* {showSchedules && (
                            <>
                                <IconButton className={classes.bottomButtonVisibilityIcon}>
                                    <Tooltip title={i18n.t("tickets.buttons.scredule")}>
                                        <EventIcon
                                            // color="primary"
                                            onClick={handleOpenScheduleModal}
                                        />
                                    </Tooltip>
                                </IconButton>
                            </>
                        )} */}

            {/* BotÃƒÂ£o FollowUp - fora do menu */}
            <FloupSelector contact={contact} ticket={ticket} />

            {/* BotÃƒÂ£o Resolver - fora do menu */}
            <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleClickResolver}
              >
                <HighlightOffIcon />
              </IconButton>
            </Tooltip>

            {/* BotÃƒÂ£o Transferir - fora do menu */}
            <Tooltip title="Transferir Ticket">
              <IconButton
                className={classes.bottomButtonVisibilityIcon}
                onClick={handleOpenTransferModal}
              >
                <SwapHorizOutlined />
              </IconButton>
            </Tooltip>

            {confirmationOpen && (
              <ConfirmationModal
                title={`${i18n.t(
                  "ticketOptionsMenu.confirmationModal.title"
                )} #${ticket.id}?`}
                open={confirmationOpen}
                onClose={setConfirmationOpen}
                onConfirm={handleDeleteTicket}
              >
                {i18n.t("ticketOptionsMenu.confirmationModal.message")}
              </ConfirmationModal>
            )}
            {transferTicketModalOpen && (
              <TransferTicketModalCustom
                modalOpen={transferTicketModalOpen}
                onClose={handleCloseTransferTicketModal}
                ticketid={ticket.id}
                ticket={ticket}
              />
            )}
          </>
        )}
        {ticket.status === "pending" &&
          (ticket.queueId === null || ticket.queueId === undefined) && (
            <ButtonWithSpinner
              loading={loading}
              size="small"
              variant="contained"
              onClick={(e) => handleOpenAcceptTicketWithouSelectQueue()}
            >
              {i18n.t("messagesList.header.buttons.accept")}
            </ButtonWithSpinner>
          )}
        {ticket.status === "pending" && ticket.queueId !== null && (
          <ButtonWithSpinner
            loading={loading}
            size="small"
            variant="contained"
            // color="primary"
            onClick={(e) => handleUpdateTicketStatus(e, "open", user?.id)}
          >
            {i18n.t("messagesList.header.buttons.accept")}
          </ButtonWithSpinner>
        )}
        <IconButton
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
          style={{ paddingHorizontal: 3, paddingTop: 10 }}
        >
          <MoreVert style={{ fontSize: 16, padding: 0 }} />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={menuOpen}
          onClose={handleCloseMenu}
        >
          {(ticket.status === "open" || ticket.status === "group") && [
            showWavoipCall && (
              <MenuItem key="wavoip-call" onClick={() => { handleOpenWavoipCall(); handleCloseMenu(); }}>
                <Phone style={{ marginRight: 8, fontSize: 20 }} />
                Ligar
              </MenuItem>
            ),
            <MenuItem key="disable-bot" onClick={() => { handleContactToggleDisableBot(); handleCloseMenu(); }}>
              <Switch
                size="small"
                checked={disableBot}
                onClick={(e) => e.stopPropagation()}
                onChange={() => handleContactToggleDisableBot()}
                style={{ marginRight: 8 }}
              />
              {disableBot ? "Ativar Bot" : "Desabilitar Bot"}
            </MenuItem>,
            <MenuItem key="return-queue" onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}>
              <UndoIcon style={{ marginRight: 8, fontSize: 20 }} />
              {i18n.t("tickets.buttons.returnQueue")}
            </MenuItem>
          ]}
          <MenuItem onClick={handleOpenConfirmationModal}>
            <Can
              role={user.profile}
              perform="ticket-options:deleteTicket"
              yes={() => i18n.t("tickets.buttons.deleteTicket")}
            />
          </MenuItem>
          <MenuItem onClick={handleEnableIntegration}>
            {enableIntegration === true
              ? i18n.t("messagesList.header.buttons.disableIntegration")
              : i18n.t("messagesList.header.buttons.enableIntegration")}
          </MenuItem>
          <MenuItem onClick={handleShowLogTicket}>
            {i18n.t("messagesList.header.buttons.logTicket")}
          </MenuItem>
          <MenuItem onClick={() => { handleOpenCrmLeadModal(); handleCloseMenu(); }}>
            Enviar para CRM
          </MenuItem>
          <MenuItem onClick={handleExportPDF}>
            {i18n.t("ticketsList.buttons.exportAsPDF")}
          </MenuItem>
        </Menu>
      </div>
      <>
        {(!user.finalizacaoComValorVendaAtiva ||
          user.finalizacaoComValorVendaAtiva === false ||
          user.finalizacaoComValorVendaAtiva === "false") && (
            <Formik
              enableReinitialize={true}
              validationSchema={SessionSchema}
              innerRef={formRef}
              onSubmit={(values, actions) => {
                setTimeout(() => {
                  actions.setSubmitting(false);
                  actions.resetForm();
                }, 400);
              }}
            >
              {({
                values,
                touched,
                errors,
                isSubmitting,
                setFieldValue,
                resetForm,
              }) => (
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <Form>
                    <DialogActions className={classes.botoes}>
                      <Button
                        onClick={() => handleFinalizarTicket("semDespedida")}
                        style={{
                          background: theme.palette.primary.main,
                          color: "white",
                        }}
                      >
                        {i18n.t(
                          "messagesList.header.dialogRatingWithoutFarewellMsg"
                        )}
                      </Button>

                      <Button
                        onClick={() => handleFinalizarTicket("comDespedida")}
                        style={{
                          background: theme.palette.primary.main,
                          color: "white",
                        }}
                      >
                        {i18n.t("messagesList.header.dialogRatingCancel")}
                      </Button>

                      {showTestButton && (
                        <Button
                          onClick={handleTestButton}
                          style={{
                            background: theme.palette.primary.main,
                            color: "white",
                          }}
                        >
                          {i18n.t(
                            "whatsappModalRel.form.resolveAndTriggerIntegration"
                          )}
                        </Button>
                      )}
                    </DialogActions>
                  </Form>
                </Dialog>
              )}
            </Formik>
          )}
      </>
      {openFinalizacaoVenda && (
            <FinalizacaoVendaModal
              open={openFinalizacaoVenda}
              onClose={() => setOpenFinalizacaoVenda(false)}
              ticket={ticket}
              onFinalizar={(ticketData) => {
                setOpenFinalizacaoVenda(false);
                setTicketDataToFinalize(ticketData);
                setShowFinalizacaoOptions(true);
              }}
            />
          )}
      {showFinalizacaoOptions && (
        <Dialog
          open={showFinalizacaoOptions}
          onClose={() => setShowFinalizacaoOptions(false)}
          aria-labelledby="finalizacao-options-title"
        >
          <DialogTitle id="finalizacao-options-title">
            Como deseja finalizar?
          </DialogTitle>
          <DialogActions className={classes.botoes}>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  false,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
            </Button>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  true,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingCancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default TicketActionButtonsCustom;
